// @ts-nocheck
/* eslint-enable */
import React from 'react';
import { connect } from 'react-redux';
import RouteActions from 'app/shared/flux/actions/RouteActions';
import UserSearchActions from 'app/shared/flux/actions/UserSearchActions';
import gmapUtils from 'app/client/utils/map/gmapUtils';
import IconPlus from 'images/icons/plus.svg';
import './style.scss';

class WidenSearchButton extends React.Component {
  constructor(props) {
    super(props);
  }

  handleWidenSearch = () => {
    const { dispatch } = this.props;
    const mapData = gmapUtils.getMapData(window.map);
    mapData.border = false;
    dispatch(RouteActions.updateUrlWithMapData(mapData));
    dispatch(UserSearchActions.setCurrentSearch({ mapData }));
  };

  render() {
    return (
      <div onClick={this.handleWidenSearch} className="WidenSearchButton">
        <span className="WidenSearchButton-plus-icon">
          <img src={IconPlus} height="12" width="12" />
        </span>
        <span className="WidenSearchButton-text">
          Widen search outside of <b>{this.props.area.name}</b>
        </span>
      </div>
    );
  }
}

export default connect()(WidenSearchButton);
